var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58921 21.8312C5.48762 20.5794 4.38608 19.2775 3.68504 17.7253C2.98406 16.0729 2.78376 14.1702 3.13427 12.3677C3.48479 10.5651 4.2859 8.86265 5.43758 7.4106C5.33745 8.6624 5.78809 9.96424 6.63929 10.9156C6.13856 8.51218 6.93972 5.90845 8.54199 4.00575C10.1443 2.10305 12.3474 0.8512 14.6507 0C13.4991 1.20172 13.3489 3.10442 13.7995 4.70674C14.2501 6.30901 15.2015 7.71102 16.0527 9.16308C16.9039 10.6151 17.7051 12.1173 17.7552 13.7696C18.2058 12.9184 18.7065 12.0672 19.007 11.1159C19.3074 10.1645 19.4576 9.16308 19.2073 8.21171C20.1086 9.3133 20.6093 10.4148 20.8596 11.8169C21.11 13.2189 21.0599 14.6709 20.9097 16.0729C20.7094 17.6252 20.3089 19.2275 19.4577 20.5293C18.4562 22.0815 16.8539 23.1831 15.1014 23.7839C11.9969 24.3347 8.94255 23.8841 6.58921 21.8312Z",
    fill: "#151B26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3945 23.6841C14.5003 25.2864 18.5561 20.4295 16.3029 16.6741C16.3029 16.624 16.2528 16.624 16.2528 16.574C16.4531 18.6269 15.9523 20.129 15.001 20.9803C15.5017 19.7786 15.1512 18.3765 14.5503 17.1748C13.9495 16.0232 13.0983 14.9717 12.4473 13.8701C11.7964 12.7185 11.2957 11.4166 11.5961 10.1147C10.3944 11.016 9.54321 12.368 9.19269 13.82C8.84218 15.2721 9.04248 16.8744 9.69342 18.2263C8.94235 17.6756 8.39158 16.7743 8.34149 15.8229C7.54033 16.7743 7.03965 18.026 7.08969 19.2778C7.08974 21.2306 8.64192 22.9831 10.3945 23.6841Z",
    fill: "#EAECEF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default ForwardRef;